import { render, staticRenderFns } from "./OrgChartTree.vue?vue&type=template&id=1c069ee8&scoped=true&"
import script from "./OrgChartTree.vue?vue&type=script&lang=js&"
export * from "./OrgChartTree.vue?vue&type=script&lang=js&"
import style0 from "./OrgChartTree.vue?vue&type=style&index=0&id=1c069ee8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c069ee8",
  null
  
)

export default component.exports